/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * In Angular 16+, most browser polyfills are handled automatically based on your
 * browser configuration. Typically you only need to import Zone.js here.
 */

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
(window as any).global = window;

